import { createRoot } from "react-dom/client";
import { Component } from "react";

import { createStore, applyMiddleware, compose, Store } from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";

import { rootReducer } from "./Reducers/root";

import { IStore, IInitialSettings, State } from "./DataTypes/storeTypes";
import { MainConnected } from "./React/Main";
import { getDefaultState } from "./storeManager";
import { updateClientData, updateState } from "./Actions/actions";
import { IAccountModel } from "../Common/accountModel";
import { listenEvent, EventNames } from "../portalEvents";
import { GlobalThemeProvider } from "@powerdiary/components-library/lib";

export class AccountProvider extends Component<IInitialSettings> {
    store: Store<IStore>;

    constructor(props: IInitialSettings) {
        super(props);

        const data = getDefaultState(props);

        //in order to use redux devtools extension
        const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
        this.store = createStore(rootReducer, data, composeEnhancers(applyMiddleware(thunkMiddleware)));
    }

    render() {
        return (
            <Provider store={this.store}>
                <MainConnected />
            </Provider>
        );
    }

    componentDidMount() {
        const settings = this.store.getState().initialSettings;

        const hasGoClientNumber = settings.registerClientNumber;

        if (hasGoClientNumber) {
            const store = this.store;

            if (settings.isLoginRequired) {
                if (settings.clientHasEmailPassword) {
                    if (!settings.registerClientNumberSameAsLoggedInClient) {
                        store.dispatch(updateState(State.Login));
                    } else {
                        if (settings.redirectUrl) {
                            window.location.assign(settings.redirectUrl);
                        }
                    }
                } else {
                    store.dispatch(updateState(State.Register));
                }
            } else {
                window.location.assign(settings.redirectUrl);
            }
        }

        listenEvent<IAccountModel>(EventNames.LoginStatusUpdate, (data) => {
            this.store.dispatch(updateClientData(data));
        });

        listenEvent<IAccountModel>(EventNames.LoginStatusUpdate, (data) => {
            this.store.dispatch(updateClientData(data));
        });
    }
}

export const renderAccountView = (params: IInitialSettings, mountPoint: string) => {
    const container = document.getElementById(mountPoint);
    const root = createRoot(container);
    root.render(
        <GlobalThemeProvider>
            <AccountProvider {...params} />
        </GlobalThemeProvider>
    );
};
